<template>
  <Posts :object="object" :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts"
import Default from "@/modules/post/pages/posts/services/Default"
import {useRoute} from "vue-router"
import Helper from "@/services/Helper"

export default defineComponent({
  name: "Default",
  components: {
    Posts
  },
  setup() {
    const route = useRoute()

    let version = ref(0)
    let object = new Default()
    let typeIds = []

    let paramsQuery = reactive({
      channelId: parseInt(route.params["channel_id"]),
    })

    function getChannelId() {
      return paramsQuery.channelId
    }

    if (isChannelSite()) {
      typeIds.push(6, 7, 8, 9, 10, 12, 13, 14)
    } else {
      typeIds.push(1)
    }

    let params = {
      title: "Все посты",
      h1: "Посты",
      page: "posts",
      type_ids: typeIds,
      channel_id: getChannelId(),
    }

    onMounted(() => {
      version.value++
    })

    function isChannelSite() {
      let channelId = parseInt(route.params.channel_id)
      return Helper.inArray([channelId], [1])
    }

    return {
      object,
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
